///<reference path="./ScrollObjectBase.ts"/>

namespace khi.bk117.view.parts.scroll
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Sprite = com.enirva.display.Sprite;
	import Tween = com.enirva.tween.Tween;
	
	import ScrollObjectBase = khi.bk117.view.parts.scroll.ScrollObjectBase;

	/*
	 * フェードオブジェクト
	 */
	export class FadeMotionObject extends ScrollObjectBase
	{
		private delay:number;
		
		public force:boolean;

		public speed:number;

		private prop:string;

		private isHorizontal:boolean;

		constructor(target:JQuery, iniValue:number = 50)
		{
      super(target);
      
			this.delay = 0;
			this.speed = 0.01;
			this.force = false;
			this.prop = "y";

      const cls:string[] = target.attr("class").split(" ");
      for (var i:number = 0; i < cls.length; i++)
      {
        if (cls[i].indexOf("D_") >= 0)
        {
          this.delay = parseInt(cls[i].replace("D_", ""));
          //break;
				}
				else if (cls[i].indexOf("FORCE") >= 0)
				{
					this.force = true;
				}
				else if(cls[i].indexOf("INI_") >= 0)
				{
					iniValue = parseFloat(cls[i].replace("INI_", ""));
				}
				else if(cls[i].indexOf("SP_") >= 0)
				{
					this.speed = parseFloat(cls[i].replace("SP_", "")) / 1000;
				}
				else if (cls[i].indexOf("HORIZONTAL") >= 0)
				{
					this.isHorizontal = true;
					this.prop = "x";
				}
      }

      this.spt.alpha = 0;
      this.spt[this.prop] = iniValue;
			this.spt.update();
		}


		public update(curr:number, winH:number, isForce:boolean = false):void
		{
			if (!this.isShow)
			{
				if (this.force || ((curr + winH - this.showThresholdY) > this.offsetY))
				{
					this.isShow = true;
					//Tween.fadeIn(this.spt, 0.05);
					Tween.motion(this.spt, ["alpha", this.prop], [1, 0], this.speed, this.delay);
				}
			}
		}
	}
}

